export default __webpack_public_path__ + "static/media/illustrativeUmbrella.e7a368f3.svg";